import { OrganizerUserDto, OrganizerUser } from 'modules/roles-manager/domain/interfaces/organizer-user';

export function mapOrganizerUserResponseDto(users: OrganizerUserDto[]): OrganizerUser[] {
  return users.map((user) => {
    const { middle_name, birth_date, enabled_notifications, is_confirmed_email, is_active, created_at, updated_at, ...rest } = user;

    return {
      ...rest,
      birthDate: birth_date,
      middleName: middle_name,
      enabledNotifications: enabled_notifications,
      isConfirmedEmail: is_confirmed_email,
      isActive: is_active,
      createdAt: created_at,
      updatedAt: updated_at,
    };
  });
}
